module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"dk":{"sustainabilityOverview":"Overblik Over Bæredygtighed","monthlyStatistics":"Månedsstatistik","disposal":"Affald","electricityDevelopment":"Udvikling, elforbrug","heatingDevelopment":"Udvikling, varme","waterDevelopment":"Udvikling, vand","wasteDevelopment":"Udvikling, affald","dataProvidedBy":"Data fra","quantityMeasurementUnit":"Enhed"}}')
  delete Component.options._Ctor
}
